import React from "react";
import styled from "styled-components";
import { LifeAtButtonV2 } from "@common/LifeAtButtonV2/LifeAtButtonV2";
import { FontSize } from "@themes/Fonts";
import { WidgetCategory } from "../../WidgetWorkspaceTypes";

const ToolbarWidgetIcon = styled.span`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    svg.toolbar-widget-icon {
        scale: 1.2;
        fill: ${(props) => props.theme.iconColor} !important;
        fill-rule: evenodd;
        &.active {
            fill: ${(props) => props.theme.textColorSpecial} !important;
        }
        &.disabled {
            fill: #919498;
        }
    }
`;

const ToolbarElementContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 50px;
`;

const WidgetTitle = styled.span<{ isActive: boolean }>`
    color: ${(props) => (props.isActive ? props.theme.textColorSpecial : props.theme.textColorPrimary)};
    font-size: ${FontSize.small};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 50px;
`;

const WidgetButtonContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
`;

const WidgetButton = styled(LifeAtButtonV2)`
    width: 50px;
`;

interface ToolbarWidgetProps {
    key: string;
    id: string;
    name: string;
    icon: any;
    isOpen: boolean;
    handleClick: () => void;
    requiresUserAccount: boolean;
    category: WidgetCategory;
}
export default function WidgetToolbarElement(props: ToolbarWidgetProps) {
    return (
        <ToolbarElementContainer
            id={
                `widget-toolbar-element-${props.name.toLowerCase()}` // required for Frigade tooltip to anchor to this component.
            }
        >
            <WidgetButton onClick={props.handleClick} variant={"solid"} size={"large"} shape={"square"}>
                <WidgetButtonContent>
                    <ToolbarWidgetIcon className={"widget-icon"}>{props.icon}</ToolbarWidgetIcon>
                    <WidgetTitle isActive={props.isOpen}>{props.name}</WidgetTitle>
                </WidgetButtonContent>
            </WidgetButton>
        </ToolbarElementContainer>
    );
}
